/**
 * @generated SignedSource<<5bd7130fed6111fb147e3ea2db413515>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScheduleDayOfMonth = "FIRST_WORKING_DAY" | "LAST_WORKING_DAY" | "DAY_1" | "DAY_15" | "LAST_DAY" | "FIRST_MONDAY" | "LAST_FRIDAY" | "%future added value";
export type ScheduleFrequency = "WEEKLY" | "BIWEEKLY" | "FOUR_WEEKLY" | "MONTHLY" | "QUARTERLY" | "%future added value";
export type ScheduleWeekday = "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY" | "%future added value";
export type DeleteScheduleInput = {
  consumer: string;
  scheduleId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type scheduleMutationsDeleteMutation$variables = {
  input: DeleteScheduleInput;
};
export type scheduleMutationsDeleteMutation$data = {
  readonly deleteSchedule: {
    readonly scheduleSet: {
      readonly id: string;
      readonly consumer: string;
      readonly enabled: boolean;
      readonly schedules: ReadonlyArray<{
        readonly id: string;
        readonly scheduleId: string;
        readonly frequency: ScheduleFrequency;
        readonly dayOfMonth: ScheduleDayOfMonth | null;
        readonly weekdays: ReadonlyArray<ScheduleWeekday>;
        readonly timeOfDay: string;
        readonly timezone: string;
      }>;
    } | null;
  } | null;
};
export type scheduleMutationsDeleteMutation = {
  variables: scheduleMutationsDeleteMutation$variables;
  response: scheduleMutationsDeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSchedulePayload",
    "kind": "LinkedField",
    "name": "deleteSchedule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ScheduleSet",
        "kind": "LinkedField",
        "name": "scheduleSet",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "consumer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Schedule",
            "kind": "LinkedField",
            "name": "schedules",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scheduleId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "frequency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dayOfMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weekdays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeOfDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timezone",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "scheduleMutationsDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "scheduleMutationsDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8b91c43a22281843946c2574dbf65429",
    "id": null,
    "metadata": {},
    "name": "scheduleMutationsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation scheduleMutationsDeleteMutation(\n  $input: DeleteScheduleInput!\n) {\n  deleteSchedule(input: $input) {\n    scheduleSet {\n      id\n      consumer\n      enabled\n      schedules {\n        id\n        scheduleId\n        frequency\n        dayOfMonth\n        weekdays\n        timeOfDay\n        timezone\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "51933f06abb2b672858cc57ebd184b46";

export default node;
